import { defaultComplaintFilter } from "../../Utils/Constants/Complaints";
import { defaultLiveFeedFilter } from "../../Utils/Constants/LiveFeed";
import { defaultLocationFilter } from "../../Utils/Constants/Locations";
import { defaultProcedureHistoryFilter } from "../../Utils/Constants/ProcedureHistory";
import { defaultProcedureFilter } from "../../Utils/Constants/Procedures";
import { defaultReportFilter } from "../../Utils/Constants/Reports";
import { defaultTracksFilter } from "../../Utils/Constants/Tracks";
import {
  defaultCapturesFilter,
  defaultWorkforceFilter
} from "../../Utils/Constants/Workforce";

const tableReducer = (
  state = {
    loading: false,
    locations: {
      searchKey: "",
      selectedLocation: null,
      filter: defaultLocationFilter,
      pageNumber: 1,
      sort: {
        title: "PCT #",
        ascending: true
      }
    },
    complaints: {
      searchKey: "",
      selectedComplaint: null,
      filter: defaultComplaintFilter,
      pageNumber: 1,
      sort: {
        title: "UPDATED AT",
        ascending: true
      }
    },
    procedures: {
      searchKey: "",
      selectedProcedure: null,
      filter: defaultProcedureFilter,
      pageNumber: 1,
      sort: {
        title: "TITLE",
        ascending: true
      }
    },
    reports: {
      searchKey: "",
      selectedProcedure: null,
      filter: defaultReportFilter,
      pageNumber: 1,
      sort: {
        title: "UPLOADED AT",
        ascending: false
      }
    },
    procedureHistory: {
      searchKey: "",
      selectedProcedureHistory: null,
      filter: defaultProcedureHistoryFilter,
      pageNumber: 1,
      sort: {
        title: "CREATED AT",
        ascending: true
      }
    },
    workforce: {
      searchKey: "",
      selectedEmployee: null,
      filter: defaultWorkforceFilter,
      captureFilter: defaultCapturesFilter,
      pageNumber: 1,
      sort: {
        title: "NAME",
        ascending: true
      }
    },
    tracks: {
      searchKey: "",
      filter: defaultTracksFilter
    },
    liveFeed: {
      filter: defaultLiveFeedFilter
    }
  },
  action
) => {
  switch (action.type) {
    // General
    case "SET_TABLE_LOADING":
      return {
        ...state,
        loading: action.payload.loading
      };

    case "SORT_BY_CATEGORY":
      return {
        ...state,
        [action.payload.category]: {
          ...state[action.payload.category],
          sort: action.payload.sort
        }
      };

    // Locations
    case "PUT_SELECTED_LOCATION":
      return {
        ...state,
        locations: { ...state.locations, selectedLocation: action.payload.id }
      };

    case "PUT_LOCATIONS_FILTER":
      return {
        ...state,
        locations: {
          ...state.locations,
          filter: action.payload.filter
        }
      };

    case "PUT_LOCATIONS_SORT":
      return {
        ...state,
        locations: {
          ...state.locations,
          sort: action.payload.sort
        }
      };

    case "PUT_LOCATIONS_SEARCH_KEY":
      return {
        ...state,
        locations: {
          ...state.locations,
          searchKey: action.payload.searchKey
        }
      };

    case "PUT_LOCATIONS_PAGE_NUMBER":
      return {
        ...state,
        locations: {
          ...state.locations,
          pageNumber: action.payload.pageNumber
        }
      };

    // Complaints
    case "PUT_SELECTED_COMPLAINT":
      return {
        ...state,
        complaints: {
          ...state.complaints,
          selectedComplaint: action.payload.data
        }
      };

    case "PUT_COMPLAINTS_FILTER":
      return {
        ...state,
        complaints: {
          ...state.complaints,
          filter: action.payload.filter
        }
      };

    case "PUT_COMPLAINTS_SORT":
      return {
        ...state,
        complaints: {
          ...state.complaints,
          sort: action.payload.sort
        }
      };

    case "PUT_COMPLAINTS_SEARCH_KEY":
      return {
        ...state,
        complaints: {
          ...state.complaints,
          searchKey: action.payload.searchKey
        }
      };

    case "PUT_COMPLAINTS_PAGE_NUMBER":
      return {
        ...state,
        complaints: {
          ...state.complaints,
          pageNumber: action.payload.pageNumber
        }
      };

    // Procedures
    case "PUT_SELECTED_PROCEDURE":
      return {
        ...state,
        procedures: {
          ...state.procedures,
          selectedProcedure: action.payload.id
        }
      };

    case "PUT_PROCEDURES_FILTER":
      return {
        ...state,
        procedures: {
          ...state.procedures,
          filter: action.payload.filter
        }
      };

    case "PUT_PROCEDURES_SORT":
      return {
        ...state,
        procedures: {
          ...state.procedures,
          sort: action.payload.sort
        }
      };

    case "PUT_PROCEDURES_SEARCH_KEY":
      return {
        ...state,
        procedures: {
          ...state.procedures,
          searchKey: action.payload.searchKey
        }
      };

    case "PUT_PROCEDURES_PAGE_NUMBER":
      return {
        ...state,
        procedures: {
          ...state.procedures,
          pageNumber: action.payload.pageNumber
        }
      };

    // Procedure History
    case "PUT_SELECTED_PROCEDURE_HISTORY":
      return {
        ...state,
        procedureHistory: {
          ...state.procedureHistory,
          selectedProcedureHistory: action.payload.id
        }
      };

    case "PUT_PROCEDURES_HISTORY_FILTER":
      return {
        ...state,
        procedureHistory: {
          ...state.procedureHistory,
          filter: action.payload.filter
        }
      };

    case "PUT_PROCEDURE_HISTORY_SORT":
      return {
        ...state,
        procedureHistory: {
          ...state.procedureHistory,
          sort: action.payload.sort
        }
      };

    case "PUT_PROCEDURE_HISTORY_SEARCH_KEY":
      return {
        ...state,
        procedureHistory: {
          ...state.procedureHistory,
          searchKey: action.payload.searchKey
        }
      };

    case "PUT_PROCEDURE_HISTORY_PAGE_NUMBER":
      return {
        ...state,
        procedureHistory: {
          ...state.procedureHistory,
          pageNumber: action.payload.pageNumber
        }
      };

    // Workforce
    case "PUT_SELECTED_EMPLOYEE":
      return {
        ...state,
        workforce: {
          ...state.workforce,
          selectedEmployee: action.payload.id
        }
      };

    case "PUT_WORKFORCE_FILTER":
      return {
        ...state,
        workforce: {
          ...state.workforce,
          filter: action.payload.filter
        }
      };

    case "PUT_WORKFORCE_CAPTURE_FILTER":
      return {
        ...state,
        workforce: {
          ...state.workforce,
          captureFilter: action.payload.filter
        }
      };

    case "PUT_WORKFORCE_SORT":
      return {
        ...state,
        workforce: {
          ...state.workforce,
          sort: action.payload.sort
        }
      };

    case "PUT_WORKFORCE_SEARCH_KEY":
      return {
        ...state,
        workforce: {
          ...state.workforce,
          searchKey: action.payload.searchKey
        }
      };

    case "PUT_WORKFORCE_PAGE_NUMBER":
      return {
        ...state,
        workforce: {
          ...state.workforce,
          pageNumber: action.payload.pageNumber
        }
      };

    // Reports
    case "PUT_SELECTED_REPORT":
      return {
        ...state,
        reports: {
          ...state.reports,
          selectedReport: action.payload.id
        }
      };

    case "PUT_REPORTS_FILTER":
      return {
        ...state,
        reports: {
          ...state.reports,
          filter: action.payload.filter
        }
      };

    case "PUT_REPORTS_SORT":
      return {
        ...state,
        reports: {
          ...state.reports,
          sort: action.payload.sort
        }
      };

    case "PUT_REPORTS_SEARCH_KEY":
      return {
        ...state,
        reports: {
          ...state.reports,
          searchKey: action.payload.searchKey
        }
      };

    case "PUT_REPORTS_PAGE_NUMBER":
      return {
        ...state,
        reports: {
          ...state.reports,
          pageNumber: action.payload.pageNumber
        }
      };

    // Tracks
    case "PUT_TRACKS_FILTER":
      return {
        ...state,
        tracks: {
          ...state.tracks,
          filter: action.payload.filter
        }
      };

    // LiveFeed
    case "PUT_LIVE_FEED_FILTER":
      return {
        ...state,
        liveFeed: {
          ...state.liveFeed,
          filter: action.payload.filter
        }
      };

    // Reset
    case "RESET":
      return state;

    default:
      return state;
  }
};
export default tableReducer;
